import type { KontaktOhneNummer } from "@/lib/kontakte";

export type MissingNumberFilter = "alle" | "kunde" | "lieferant";

export function filterKontakteOhneNummer(
  items: readonly KontaktOhneNummer[],
  filter: MissingNumberFilter,
  query: string,
): KontaktOhneNummer[] {
  const needle = query.trim().toLowerCase();
  return items.filter((item) => {
    if (filter !== "alle" && item.typ !== filter) return false;
    if (!needle) return true;
    const haystack = [item.firmenname, item.plz, item.ort, item.email]
      .filter((part) => part && String(part).trim())
      .join(" ")
      .toLowerCase();
    return haystack.includes(needle);
  });
}
